import {connect, useDispatch, useSelector} from "react-redux";
import {AppState} from "../../RootReducer";
import {Dispatch} from "redux";
import React, {useEffect} from "react";
import {
    setWithdrawAmount, updateDestinationTag,
    updateNotesTag,
    updateOrderCustom,
    updateWithdrawAddress,
    updateWithdrawAmount
} from "../../payments/WithdrawActions";
import {GlobalPayload} from "../../contenful/types";
import Title from "../../layout/Title"
import './../Withdraw.scss';
import TextField from "../../layout/TextField";
import {PaymentInput, PaymentInputType, PaymentMethod, Settings, UserInfo, WithdrawContext} from "../../http/protocol";
import {t} from "../../i18n";
import {getContainer} from "../../ioc/IOCSetup";
import {BrandA} from "../buttons/buttons";
import {SelectInput} from "../../user/ui/form";
import PhoneInput from "react-phone-input-2";
import {usePrevious} from "../../user/ui/utils";
import { AddressValidationResultCode, toCanonicalSymbol, validateCryptoAddress } from "../../payments/CryptoAddressValidator";

const inputRegExp = /[<>;"'/\\|]/;

interface Props  {
    updateAddress? : (recipientAddress : string) => void,
    updateDestinationTag? : (destinationTag : string) => void;
    updateNotesTag? : (notesTag : string) => void;
    setWithdrawAmount? : ()=>void;
    recipientAddress?:string;
    amount?: string;
    currency?: string;
    settings?: Settings;
    global?: GlobalPayload;
    paymentMethod? : PaymentMethod;
    updateAmount: typeof updateWithdrawAmount;
    user?:UserInfo;
    code?:string;
    context? : WithdrawContext;
    orderCustom? : any;
    destinationTag?: string;
}

interface State {
    showCurrency:boolean;
    isCrypto: boolean;
    storedRecipientAddress: string;
    storedDestinationTag?: string;
    storedNotesTag?: string;
    validAddress:boolean;
    validDestinationTag?: boolean;
    errorMessage:string;
    destinationTagErrorMessage? : string;
}


export class ChooseAddress extends React.Component<Props, State> {
    addressEntered: boolean = false;

    constructor(props: Props) {
        super(props);
        this.state = {
            showCurrency: false,
            isCrypto : false,
            storedRecipientAddress : "",
            validAddress:false,
            validDestinationTag : false,
            errorMessage:""
        }
    }

    handleClickChangeCurrency = () => {
        this.setState({showCurrency: !this.state.showCurrency});
    };

    checkIfCrypto() {

        if(this.props.context?.cryptoContext?.network) {
            this.setState({ isCrypto : true });
        }
        let currencies = this.props.user && this.props.user.currencies;
        let activeCurrency = this.props.currency;

        if(currencies) {
            currencies.forEach((currency) => {
                if(currency.code == activeCurrency) {
                    if(currency.cryptoCurrency) {
                        this.setState({isCrypto:true})
                    }
                }
            })
        }
    }

    getStoredRecipientAddress() {
        let key = `${this.props.paymentMethod && this.props.paymentMethod.code}-${this.props.currency}-withdrawAddress`;
        getContainer().getUserService().getUserSettings(key).then((data) => {
            let address = data;
            if(data && data.length > 0 && data.indexOf(":") != -1) {
                let parts = data.split(":");
                address = parts[0];
                let tag = parts[1];
                this.props.updateDestinationTag?.(tag);
                this.setState({ storedDestinationTag : tag})
            }
            this.props.updateAddress && this.props.updateAddress(address);
            this.setState({storedRecipientAddress:address});
        })
    }

    componentDidMount(): void {
		if((this.props.paymentMethod && this.props.paymentMethod.code == "COINPAYMENTS")) {
			this.setState({isCrypto:true});
		} else {
			this.checkIfCrypto();
		}
		this.getStoredRecipientAddress();

		this.props.updateAmount && this.props.updateAmount("");
	}

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if(this.state.storedRecipientAddress !== prevState.storedRecipientAddress) {
            this.validateAddress();
        }
        if(this.state.storedDestinationTag != prevState.storedDestinationTag) {
            this.validateDestinationTag();
        }
        if(prevProps.code !== this.props.code) {
            this.getStoredRecipientAddress()
        }
        if(this.props.destinationTag != prevProps.destinationTag) {
            this.validateDestinationTag();
        }
        if(this.props.recipientAddress !== prevProps.recipientAddress) {
            this.validateAddress();
        }
    }
    validateDestinationTag() {
        if(this.hasDestinationTag()) {
            if(this.props.destinationTag && this.props.destinationTag.length > 0 && "" + parseInt(this.props.destinationTag) == this.props.destinationTag) {
                this.setState({ validDestinationTag : true, destinationTagErrorMessage : undefined});
            } else {
                let empty = !this.props.destinationTag ||  this.props.destinationTag.length == 0;
                this.setState({ validDestinationTag : false, destinationTagErrorMessage : empty ? undefined  : t("payments.invalid-destination-tag") });
            }
        } else {
            this.setState({ validDestinationTag : true });
        }

    }
    validateAddress() {
        if(this.props.recipientAddress && this.props.recipientAddress.length > 0) {
            let currency = this.props.context?.cryptoContext?.network ?? this.props.currency!;
            const BTC_VALIDATION = /^([13][a-km-zA-HJ-NP-Z1-9]{25,34}|bc1[ac-hj-np-zAC-HJ-NP-Z02-9]{11,71})$/
            if (this.state.isCrypto && this.props.paymentMethod) {
                const lightning = this.props.paymentMethod.code === "BTC_LIGHTNING"

                const validation = validateCryptoAddress(this.props.recipientAddress, currency, true, lightning)

                if (validation.result === AddressValidationResultCode.VALID) {
                    this.setState({validAddress: true, errorMessage: ""})
                } else if (lightning) {
                    this.setState({validAddress: false, errorMessage: t("payments.invalid-crypto-btc-lightning-invoice") })
                } else if (validation.result === AddressValidationResultCode.WRONG_CURRENCY) {
                    this.setState({validAddress: false, errorMessage: t("payments.invalid-crypto-address-guess", {
                        code: toCanonicalSymbol(currency).toUpperCase(),
                        guessed: validation.guessedCurrencies?.join(", ").toUpperCase()})})
                } else {
                    this.setState({validAddress: false, errorMessage: t("payments.invalid-crypto-address", {code: toCanonicalSymbol(currency).toUpperCase()}) })
                }

            } else {
                this.setState({validAddress:true, errorMessage:""});
            }
        } else {
            this.setState({validAddress:false, errorMessage:""})
        }
    }

    hasDestinationTag() {
        return this.props.code === "XRP";
    }

    hasNotesTag(){
        return this.props.code === "TON";
    }

    render() {
        const btcLn = this.props.code === "BTC_LIGHTNING";

        const showDestinationTag = this.hasDestinationTag();
        const showNotesTag = this.hasNotesTag();

        let isValid = false;
        const isInputValid = (i : PaymentInput, orderCustom : any) =>  {
            if(orderCustom && i.name && orderCustom?.[i.name]) {
                if((i.required || orderCustom[i.name].trim().length > 0) && !inputRegExp.test(orderCustom[i.name])) {
                    return true;
                }
            }
            return false;
        }

        let inputs = this.props.context?.inputs  ??  this.props.context?.customContext?.input  ??  undefined

        if(inputs) {
            isValid = (inputs as PaymentInput[]).filter(i => !isInputValid(i,this.props.orderCustom)).length == 0;
        } else {
            isValid = this.addressEntered /*&& this.state.validAddress*/;
        }


        let isValidDestinationTag = !this.hasDestinationTag() || this.state.validDestinationTag;

        this.addressEntered = !!(this.props.recipientAddress && this.props.recipientAddress.length > 0);
        return (
            <div className="choose-address-container">

                {inputs && (
                    <PaymentInputsComponent inputs={inputs} inputOrders={this.props.context?.inputOrders} />
                )}
                {!inputs && (
                    <>
                        {!btcLn && (
                            <div className="withdraw-title">
                                <Title animate={true} title={this.state.isCrypto ? t("withdrawPage.addressPhaseTitle") : `${t("forms.email.prompt")} ${this.props.paymentMethod && this.props.paymentMethod.name} ${t("forms.email.label")}:`}/>
                            </div>
                        )}
                        { btcLn && (
                            <>
                                <div className="withdraw-title">
                                <span className={"title"}>
                                    {t("payments.btc-lightning-invoice-title", { currencyCode : this.props.currency})}
                                </span>
                                </div>
                                <div className="help-text-wrapper">
                                    <span className="help-text">{t("payments.btc-lightning-warning")}</span>
                                </div>
                            </>
                        )}
                        <TextField
                            type={this.state.storedRecipientAddress.length > 0 && this.state.storedRecipientAddress.startsWith("ln") ? "textarea" : "text" }
                            onChange={(e) => {
                                this.props.updateAddress && this.props.updateAddress(e.target.value)
                                this.setState({storedRecipientAddress : e.target.value})
                            }}
                            value={this.state.storedRecipientAddress}
                            placeholder={btcLn ? t("payments.btc-lightning-invoice") : (this.state.isCrypto ? t("withdrawPage.addressPhaseLabel") : t("forms.email.label"))}/>

                        {showDestinationTag && (
                            <TextField
                                type={"text"}
                                onChange={(e)=>{
                                    this.props.updateDestinationTag?.(e.target.value)
                                    this.setState({storedDestinationTag : e.target.value})
                                }}
                                value={this.state.storedDestinationTag}
                                placeholder={t("payments.destination-tag-optional")}
                            />
                        )}
                        {showNotesTag && (
                            <TextField
                                type={"text"}
                                onChange={(e)=>{
                                    this.props.updateNotesTag?.(e.target.value)
                                    this.setState({storedNotesTag : e.target.value})
                                }}
                                value={this.state.storedNotesTag}
                                placeholder={t("payments.notes-tag-optional")}
                            />
                        )}

                    </>
                )}
                {this.state.errorMessage.length > 0 && <span className="help-text error">{this.state.errorMessage.length > 1 && this.state.errorMessage}</span>}
                {this.state.destinationTagErrorMessage && <span className="help-text error">{this.state.destinationTagErrorMessage  && this.state.destinationTagErrorMessage}</span>}
                <BrandA className={"btn btn-cta full-width large"} onClick={() => this.props.setWithdrawAmount?.()}
                        disabled={!isValid}>
                    {t("withdrawPage.withdrawButtonText1")}
                </BrandA>
            </div>
        )
    }
}
const PaymentInputsComponent = (props : {inputs : PaymentInput[], inputOrders?: { [index: string]: string[] } }) => {

    const orderCustom = useSelector((app : AppState) => app.payments.withdraw.orderCustom ?? {});

    const dispatch = useDispatch();

    let prevInputs = usePrevious(props.inputs);
    useEffect(()=>{
        if(prevInputs != props.inputs) {
            let defaultValues : any = {};
            props.inputs.forEach(i => {
                if(i.defaultValue && i.name) {
                    defaultValues[i.name] = i.defaultValue;
                } else if(i.options && i.options.split(",").length > 0  && i.name) {
                    //defaultValues[i.name] = i.options.split(",")[0];
                }
            })
            dispatch(updateOrderCustom(defaultValues));
        }
    },[props.inputs])

    const onChange = (name? : string, value? : string) => {

        if(!name) {
            return;
        }
        let update = {...orderCustom, [name] : value };
        dispatch(updateOrderCustom(update));
    }
    const country = useSelector((app: AppState) => app.user.user?.country);




    return (
        <div className={"form-popup"}>
            {props.inputs.map((i) => {
                if(i.type == PaymentInputType.PHONE_NUMBER) {
                   return (
                       <div className={"form-group"} key={i.name}>
                           <label>{t(`payment.form.${i.name}.label`)}</label>
                           <PhoneInput
                               value={orderCustom[i.name!]}
                               country={country?.toLowerCase() ?? ""}
                               onChange={(data) => onChange(i.name, data)}
                               placeholder={"1 702 123 4567"}
                               searchPlaceholder={"Search"}
                               enableSearch={true}
                               defaultMask={"... ... ... ... ..."}
                               alwaysDefaultMask={true}
                           />
                           <span className={"help"}>{t(`payment.form.${i.name}.help`)}</span>
                       </div>
                   )
                } else if(i.type == PaymentInputType.SELECT) {
                    const opts = i.options
                        ?.split(",")
                        .filter(o => o?.trim().length > 0)
                        .sort()
                        .map(o => (<option key={o} value={o} >{t(`payment.form.${i.name}.opt-${o}`)}</option>))

                    return (
                        <div className={"form-group"} key={i.name}>
                            <label>{t(`payment.form.${i.name}.label`)}</label>
                            <SelectInput className={"form-control"} onChange={(e) => onChange(i.name, e.target.value)} input={{defaultValue : ""}}>
                                <option value="" disabled={true}>{t(`payment.form.${i.name}.label`)}</option>
                                {props.inputOrders?.[i.name ?? ""] && (
                                    <>
                                        <optgroup label={t("payment.form.popular")}>
                                            {props.inputOrders[i.name ?? ""].map(s => <option key={s} value={s}>{t(`payment.form.${i.name}.opt-${s}`)}</option>)}
                                        </optgroup>
                                        <optgroup label={t("payment.form.all")}>
                                            {opts}
                                        </optgroup>
                                    </>

                                )}
                                {!props.inputOrders && (
                                    <>
                                        {opts}
                                    </>
                                )}
                            </SelectInput>
                            <span className={"help"}>{t(`payment.form.${i.name}.help`)}</span>
                        </div>
                    )
                } else {
                   return (
                     <div className={"form-group"} key={i.name}>
                       <label>{t(`payment.form.${i.name}.label`)}</label>
                       <input placeholder={t(`payment.form.${i.name}.placeholder`)} type={"text"} className={"form-control"} value={orderCustom?.[i.name!] ?? ""} onChange={(e) => onChange(i.name, e.target.value)} />
                       <span className={"help"}>{t(`payment.form.${i.name}.help`)}</span>
                     </div>
                   );
                }
            })}
        </div>
    )
}
const mapStateToProps = (app : AppState)=> {
    return {
        currency : app.payments.withdraw.activeCurrency,
        amount : app.payments.withdraw.amount,
        recipientAddress : app.payments.withdraw.recipientAddress,
        destinationTag : app.payments.withdraw.destinationTag,
        notesTag : app.payments.withdraw.notesTag,
        settings : app.settings.settings,
        global : app.contentful.global,
        paymentMethod : app.payments.withdraw.activeMethod,
        context : app.payments.withdraw.withdrawContext,
        user : app.user.user,
        orderCustom : app.payments.withdraw.orderCustom
    }
};

const mapDispatchToProps = (dispatch: Dispatch)=> ({
    updateAddress : (recipientAddress : string) => dispatch(updateWithdrawAddress(recipientAddress)),
    updateDestinationTag : (tag : string) => dispatch(updateDestinationTag(tag)),
    updateNotesTag : (tag : string) => dispatch(updateNotesTag(tag)),
    setWithdrawAmount : () => dispatch(setWithdrawAmount() as any),
    updateAmount : (amount : string) => dispatch(updateWithdrawAmount(amount)),

});

export default connect(mapStateToProps,mapDispatchToProps)(ChooseAddress);